<!-- 用户隐私协议 -->
<template>
    <div class="container">
        <h1>用户隐私协议</h1>
        <div class="date-info">更新日期：2025年12月1日。生效时间：2025年12月1日</div>
        
        <p>作为车抵典当应用程序的运营者（苏州汇通典当有限公司，以下简称"我们"），深知个人信息对您的重要性，我们将按照法律法规的规定，保护您的个人信息及隐私安全。</p>
        
        <div class="special-tip">
            <div class="special-tip-title">【特别提示】</div>
            <p>如国家有关特定条款与本协议条款存在同类条款的不一致约定，则在特定条款约束范围内应以特定条款为准。</p>
            <p>在使用我们各项产品或服务前，请您务必仔细阅读并透彻理解本政策，特别是以<strong class="highlight">粗体</strong>标识的条款，您应重点阅读，在确认充分理解并同意后使用相关产品或服务。如您对本政策有任何疑问，可联系客服咨询。如您不同意本政策中的任何条款，您应立即停止注册、使用车抵典当提供的产品与/或服务。如您使用或在车抵典当更新本政策后继续使用我们产品与/或服务，即意味着您同意本政策。</p>
        </div>
        
        <h2>一、我们如何收集和使用个人信息</h2>
        <p>我们的产品基于flutter(App/Wap2App)开发，应用运行期间需要收集您的设备序列号（<strong>IMEI</strong>/<strong>Android Id</strong>/<strong>Device_ID</strong>/<strong>IDFA</strong>/<strong>SIM卡IMSI信息</strong>/<strong>OAID</strong>）以提供统计分析服务，并通过应用启动数据及异常数据日志分析改进性能和用户体验，我们收集您的个人信息是为了您和其他用户能够有更满意的车抵典当服务。在您使用我们的服务过程中，我们会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以向您提供、优化我们的服务以及保障您的账户安全：</p>
        
        <h3>（一）我们将通过以下途径收集和获得您的个人信息或<strong>个人敏感信息</strong>：</h3>
        <ol>
            <li>您提供的信息。例如：</li>
            <ol>
                <li>您在车抵典当帐号或使用车抵典当服务时，向我们提供的信息；</li>
                <li>您通过车抵典当服务向第三方提供的共享信息，以及您使用车抵典当服务时所存储的信息。</li>
            </ol>
            <li>第三方共享的您的信息以及SDK采集的信息。</li>
            <li>我们在您使用服务时获取的信息。您在使用车抵典当服务时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息，包括SDK/API/JS代码版本、浏览器、互联网服务提供商、<strong>IP地址</strong>、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、iOS广告标识符（IDFA)、安卓广告主标识符、网卡（MAC）地址、国际移动设备识别码（<strong>IMEI</strong>）、设备型号、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况、写入外部存储，使用存储权限读取外置存储信息等。</li>
        </ol>
        
        <h3>（二）我们会出于以下目的，收集和使用您以下类型的个人信息或<strong>个人敏感信息</strong>：</h3>
        <p>我们需要特别提醒您的是：您理解并同意，我们希望提供给您的产品和服务是完善的，所以我们会不断改进我们的产品和服务，这意味着随着产品和服务的迭代、拓展、升级等，我们会经常推出新的服务或业务功能或重新划分业务功能，并需要收集新的个人信息或变更个人信息使用目的或方式。如果我们要将您的个人信息用于本政策中未载明的其他用途或额外收集未提及的其他个人信息，我们会依法通过页面提示、交互流程、公告或其他方式另行征得您的同意。</p>
        
        <ol>
            <li>帮助您完成注册及登录
                <p>为便于我们为您提供持续稳定的服务并保障您使用车抵典当的安全性，我们需要您提供基本注册或登录信息，包括手机号码、电子邮箱地址等，并创建您的帐号、用户名和密码。在部分单项服务中，如果您仅需使用浏览、搜索等基本功能，您不需要注册成为车抵典当用户及提供上述信息。</p>
                <p>您也可以在注册、登录或后续使用过程中，填写或补充您的其他额外信息（例如您的昵称、头像、性别、籍贯、职业、学历、出生日期、兴趣爱好，<strong>银行卡</strong>、<strong>身份证</strong>），这将有助于我们给您提供更优的服务体验，但如果您不提供这些信息，并不会影响您使用车抵典当服务的基本功能。</p>
            </li>
            <li>实现身份认证
                <p>依照相关法律法规规定及监管要求，或为满足用户身份真实核验、保障系统和服务安全及其他特定服务功能等需要，我们需要您提供真实身份信息（例如姓名、<strong>身份证</strong>、护照、驾驶证、户口本，本人实名制手机号等）或者其他身份信息以完成身份认证。如果您不能完成实名信息验证，我们将不能向您继续提供相关的功能及服务。</p>
                <p>为实现身份认证的目的，您同意并授权我们以自行或委托第三方向有关身份认证机构提供、查询、核对您的前述身份信息。</p>
                <p>请注意，您的身份信息、<strong>生物识别信息</strong>（包括<strong>面部识别特征</strong>）、实名制手机号等属于<strong>个人敏感信息</strong>，请您谨慎提供，如果拒绝提供您将无法获得相关服务，但不影响其他功能与服务的正常使用。</p>
            </li>
            <li>维护基本功能的正常运行
                <p>在您使用我们服务过程中，为向您提供浏览、搜索等基本功能，并识别帐号异常状态、了解产品适配性、保障车抵典当的网络及运营安全，以维护前述基本功能的正常运行，我们会直接或者间接地收集、存储关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：</p>
                <ol>
                    <li>日志信息：当您使用我们的服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如:您的登录帐号、搜索查询内容、<strong>IP地址</strong>、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、Push打开记录、停留时长、刷新记录、发布记录、关注、订阅、收藏及分享等。</li>
                    <li>设备信息：我们会接收并记录您所使用的设备相关信息。例如：设备机型、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、进程及软件列表、设备MAC地址，设备标识信息（包括<strong>IMEI</strong>/设备序列号/<strong>OAID</strong>/<strong>MEID</strong>/<strong>Android ID</strong>/<strong>IMSI</strong>/<strong>GUID</strong>/MAC地址/SIM卡序列号）、已安装APP信息或运行中的进程信息、软硬件特征信息、设备所在位置相关信息（例如<strong>IP地址</strong>、<strong>GPS位置</strong>以及能够提供相关信息的WLAN接入点、蓝牙和基站传感器信息）。我们收集这些信息是为了向您提供我们基本服务和基础功能，如您拒绝提供上述权限将导致您无法使用车抵典当服务。</li>
                </ol>
            </li>
            <li>向您提供互动与发布服务
                <p>您在使用车抵典当服务时、上传和/或发布信息以及进行相关互动行为（例如发布商品评论、分享、收藏、点赞）时，我们将收集您上传、发布或形成的信息，并使用您的昵称、头像和发布内容以作展示。</p>
                <p>请注意，您公开发布的信息中包含您的个人信息或<strong>个人敏感信息</strong>，请您在发布前慎重考虑。如您发布的信息涉及到他人的个人信息的，您应当在发布前征得他人同意。</p>
            </li>
            <li>帮助您完成下单、支付并向您交付商品或服务
                <ol>
                    <li>为向您展示帐号的交易信息并保障交易安全，我们会收集您在使用车抵典当服务过程中产生的信息（例如您所购买的商品或服务信息、具体订单号、订单创建时间、交易金额）用于向您展示及便于您对订单进行管理；</li>
                    <li>为完成订单支付、交付商品或服务、确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择商品或服务、支付机构等收集与交易进度相关的您的帐号、订单、交易、支付，或将您的交易信息共享给上述服务提供者。</li>
                </ol>
            </li>
            <li>为您提供客服或其他用户响应功能
                <p>当您联系我们的客服或使用其他用户响应功能时（例如提出售中售后申请、个人信息保护投诉或建议、其他客户投诉和需求），我们需要您提供必要的个人信息以匹配并核验您的用户身份，以便保障您的帐号与系统安全。我们还会保存您的联系方式（您与我们联系时使用的或您向我们主动提供的其他联系方式）、您与我们的通信记录和内容、与您需求相关联的其他必要信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
            </li>
            <li>我们通过间接方式收集到的您的个人信息或<strong>个人敏感信息</strong>：
                <p>基于您选择使用的车抵典当服务，我们会涉及到从关联方、第三方合作伙伴获取您授权共享的相关信息。例如，当您使用第三方平台的账号登录车抵典当服务时，我们将根据您的授权获取该第三方账号下的相关信息（包括：用户名、昵称、头像，具体以您的授权内容为准），并在您同意本政策后将您的第三方帐号与您的车抵典当服务帐号绑定，使您可以通过第三方帐号直接登录并使用车抵典当服务。我们将在符合相关法律法规规定，并依据与关联方或第三方合作伙伴的约定、确信其提供的信息来源合法的前提下，收集并使用您的这些信息。</p>
            </li>
            <li>为您提供安全保障
                <p>为提高您使用我们服务的安全性，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，我们会收集、使用或整合您的帐号信息、交易信息、设备信息（包括<strong>IMEI</strong>/设备序列号/<strong>OAID</strong>/<strong>MEID</strong>/<strong>Android ID</strong>/<strong>IMSI</strong>/<strong>GUID</strong>/MAC地址/SIM卡序列号）、已安装APP信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，综合判断您帐号及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>
            </li>
            <li>为实现垃圾清理与运行加速功能，我们将请求您的存储权限获取外置存储信息（SD卡数据），用以检查手机CPU，内存和SD卡情况。当您播放视频等内容时，为了适配您的设备状态，我们会调用设备的重力加速度等传感器信息，仅用于识别您设备的横竖屏状态，适配视频播放、地图展示的界面布局，不用于其他用途。在您分享或者接受分享的信息时，需要在本地访问你的剪切板，读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动等功能或服务。</li>
            <li>征得授权同意的例外
                <p>我们承诺，所有收集的个人信息将存储于中华人民共和国境内，并在需要跨境传输时，会单独征得您的授权同意。此外，我们仅在获得您同意的情况下，将基于特定目的收集的信息用于其他目的。</p>
                <p>根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：</p>
                <ol>
                    <li>为订立、履行您作为一方当事人的合同所必需；</li>
                    <li>为履行法定职责或者法定义务所必需；</li>
                    <li>为应对突发公共卫生事件，或者紧急情况下为保护您或他人的生命健康和财产安全所必需；</li>
                    <li>为公共利益实施新闻报道、舆论监督等行为，在合理范围内处理您的个人信息；</li>
                    <li>在合理范围内处理您自行公开或者其他已经合法公开的个人信息；</li>
                    <li>法律、行政法规规定的其他情形。</li>
                </ol>
            </li>
        </ol>
        
        <p>我们始终致力于保护您的个人信息安全，并确保您的隐私权益得到充分尊重和保护。</p>
        
        <h2>二、我们如何使用COOKIES或同类技术</h2>
        <p>我们或我们的第三方合作伙伴通过COOKIES或同类技术获取和使用您的信息，并将该等信息存储为日志信息。关于Cookie和同类技术，我们使用它们来确保网站正常运转，存储您的偏好或购物篮内的商品等数据。您可以自行管理或删除Cookie，大部分网络浏览器都设有阻止Cookie的功能。一个COOKIES是少量的数据，它们从一个网络服务器送至您的浏览器并存在计算机硬盘上。我们使用COOKIES是为了让其用户可以受益。比如，为使得车抵典当的登录过程更快捷，您可以选择把用户名存在一个COOKIES中。这样下次当您要登录车抵典当的服务时能更加方便快捷。COOKIES能帮助我们确定您连接的页面和内容，您在车抵典当特定服务上花费的时间和您所选择的车抵典当服务。</p>
        
        <p>COOKIES使得我们能更好、更快地为您服务。然而，您应该能够控制COOKIES是否以及怎样被您的浏览器接受。请查阅您的浏览器附带的文件以获得更多这方面的信息。</p>
        
        <p>我们和第三方合作伙伴会通过COOKIES或同类技术收集和使用您的信息，并将该等信息存储。</p>
        
        <p>我们使用自己的COOKIES或同类技术，用于以下一种或几种用途：</p>
        <ol>
            <li>记住您的身份。例如：COOKIES或同类技术有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信息；</li>
            <li>分析您使用我们服务的情况。我们可利用COOKIES或同类技术来了解您使用车抵典当服务进行什么活动、或哪些服务最受欢迎；</li>
            <li>您可以通过浏览器或用户选择机制拒绝或管理COOKIES或同类技术。但请您注意，如果您停用COOKIES或同类技术，我们将无法为您提供最佳的服务体验，某些服务也无法正常使用。</li>
        </ol>
        
        <h2>三、共享、转让或披露的个人信息</h2>
        <h3>（一）共享</h3>
        <p>我们非常重视保护您的个人信息或<strong>个人敏感信息</strong>。除以下情形外，未经您同意，我们不会与车抵典当之外的任何第三方共享您的个人信息：</p>
        <ol>
            <li>向您提供我们的服务。我们向合作伙伴及其他第三方共享您的信息，以实现车抵典当服务的功能，让您正常使用您需要的服务。例如：提供支付服务的支付机构、提供数据服务（包括网络监测、数据统计、数据分析）的合作伙伴；</li>
            <li>向委托我们进行推广的合作伙伴等第三方共享，目的是为了使该等委托方了解推广的覆盖面和有效性。比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客；</li>
            <li>与关联方的必要共享。为便于我们基于统一的帐号体系向您提供一致化服务以及便于您进行统一管理、保障系统和帐号安全等，您的个人信息会在我们和我们的关联方之间进行必要共享。例如：在您使用某一项车抵典当服务时所收集的您的信息，在另一项车抵典当服务中用于向您提供特定内容或向您展示与您相关的信息；</li>
            <li>实现本政策第一条"我们如何收集和使用个人信息"部分所述的其他目的；</li>
            <li>履行我们在本政策或我们与您达成的其他协议中的义务和行使我们的权利；</li>
            <li>在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他车抵典当用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们与其他公司和组织交换信息。不过，这并不包括违反本政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息；</li>
            <li>应您合法需求或经您的授权同意；</li>
            <li>应您的监护人合法要求而提供您的信息；</li>
            <li>根据与您签署的单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</li>
            <li>基于学术研究而提供；</li>
            <li>基于符合法律法规的社会公共利益而提供。</li>
        </ol>
        
        <p>我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息。</p>
        
        <h3>（二）转让</h3>
        <ol>
            <li>随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的信息作为此类交易的一部分而被转移。我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</li>
            <li>在获得您的明确同意后，我们会向第三方转让您的个人信息。</li>
        </ol>
        
        <h3>（三）披露</h3>
        <p>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的个人信息或<strong>个人敏感信息</strong>：</p>
        <ol>
            <li>根据您的需求，在您明确同意的披露方式下披露您所指定的信息；</li>
            <li>根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您信息的情况下，我们会依据所要求的信息类型和披露方式披露您的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</li>
        </ol>
        
        <h3>（四）共享、转让、披露信息时事先征得授权同意的例外</h3>
        <p>以下情形中，共享、转让、披露您的信息无需事先征得您的授权同意：</p>
        <ol>
            <li>与国家安全、国防安全直接相关的；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
            <li>与刑事侦查、起诉、审判和判决执行等司法或行政执法直接相关的；</li>
            <li>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
            <li>您自行向社会公众公开的信息；</li>
            <li>从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；</li>
            <li>与我们履行法律法规规定的义务相关的。</li>
        </ol>
        
        <p>根据法律规定，共享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
        
        <h2>四、我们如何存储和保护个人信息</h2>
        <h3>（一）个人信息的存储</h3>
        <p>我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内，不会对您的个人信息跨境传输。如将来涉及向境外传输个人信息，车抵典当将明确向您告知个人信息出境的目的、接收方、安全保障措施等情况，并另行征得您的同意。</p>
        
        <p>我们仅在为提供我们及服务之目的所必需的期间内保留您的个人信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。但在下列情况下，我们需符合法律要求，更改个人信息的存储时间：</p>
        <ol>
            <li>为遵守适用的法律法规规定，例如，《中华人民共和国网络安全法》第二十一条第三款要求监测、记录网络运行状态、网络安全事件的技术措施的网络日志留存不得少于六个月；</li>
            <li>为遵守法院判决、裁定或其他法律程序的规定；</li>
            <li>为遵守政府机关或法定授权组织的要求；</li>
            <li>为执行平台协议或本政策、维护社会公共利益，保护我们及我们关联公司、其他用户或雇员的人身安全或其他合法权益所合理必需的用途。</li>
        </ol>
        
        <p>在您的个人信息超出保留期间后，我们会删除您的个人信息，或使其匿名化处理。</p>
        
        <h3>（二）个人信息的保护</h3>
        <ol>
            <li>安全保护措施
                <p>为保障您的信息安全，我们已采取符合业界标准、合理可行的各类物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于在您的移动设备与车抵典当产品及/或服务之间交换数据时进行SSL加密保护；使用加密技术确保数据的保密性；使用受信赖的保护机制防止数据遭到恶意攻击。</p>
                <p>我们对接触到您的信息的员工采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。我们会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄漏、毁损或丢失。</p>
                <p>您的帐号均有安全保护功能，请妥善保管您的帐号及密码信息。我们将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。互联网并非绝对安全的环境，尽管有前述安全措施，但同时也请您理解在信息网络上不存在"完善的安全措施"。</p>
            </li>
            <li>安全事件处置措施
                <p>若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们将按照法律法规的要求向您告知安全事件的基本情况和影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
            </li>
        </ol>
        
        <h2>五、如何管理您的个人信息</h2>
        <h3>（一）访问、更新和删除</h3>
        <p>我们鼓励您更新和修改您的个人信息以使其更准确有效。我们将采取适当的技术手段或提供提交申请的联系渠道，保证您可以访问、更新和更正自己的个人信息或使用车抵典当服务时提供的其他信息。对于通过COOKIES或同类技术收集的您的信息，我们还在本政策第二条"我们如何使用COOKIES或同类技术"部分说明了向您提供的选择机制。</p>
        
        <p>除法律法规另有规定，当您更正、删除您的个人信息或申请注销帐号时，我们不会立即从备份系统中更正或删除相应的信息，但会在备份更新时更正或删除这些信息。</p>
        
        <h3>（二）公开与分享</h3>
        <p>我们的多项服务可让您不仅与您的社交网络、也与使用该服务的所有用户公开分享您的相关信息，例如，您在车抵典当服务中所上传或发布的信息、您对其他人上传或发布的信息作出的回应，通过电子邮件或在车抵典当服务中不特定用户可见的公开区域内上传或公布您的信息，以及包括与这些信息有关的位置数据和日志信息。只要您不删除您所公开或共享的信息，有关信息一直留存在公众领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或存储，或由其他用户或该等第三方在公众领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的信息。</p>
        
        <h3>（三）帐号注销</h3>
        <p>我们向您提供帐号注销的途径。在符合我们的服务条款约定条件及国家相关法律法规规定的情况下，您可以选择通过本政策"如何联系我们"章节所列的渠道联系我们注销账号，我们会尽快为您作出解答。</p>
        
        <p>在您的帐号注销之后，我们将停止为您提供全部或部分车抵典当服务，并依据您的要求，删除您的个人信息或做匿名化处理，但法律法规另有规定的除外。</p>
        
        <h3>（四）改变您授权同意的范围</h3>
        <p>您总是可以选择是否向我们披露个人信息。有些个人信息是使用车抵典当服务所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能、注销账号等方式改变您授权我们继续收集信息的范围或撤回您的授权。</p>
        
        <p>当撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。</p>
        
        <h3>（五）响应您的上述请求</h3>
        <p>为保障安全，您需要提供书面请求，或以其他方式证明您的身份。我们会先要求您验证自己的身份，然后再处理您的请求。对于您合理的请求，我们原则上不收取费用，但对于多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从头改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们会予以拒绝。</p>
        
        <p>在以下情形中，我们将无法响应您的请求：</p>
        <ol>
            <li>与我们履行法律法规规定的义务相关的；</li>
            <li>与国家安全、国防安全直接相关的；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
            <li>与刑事侦查、起诉、审判和执行判决等直接相关的；</li>
            <li>我们有充分证据表明您存在主观恶意或滥用权利的；</li>
            <li>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
            <li>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</li>
            <li>涉及商业秘密的。</li>
        </ol>
        
        <h2>六、第三方服务</h2>
        <p>车抵典当服务接入或链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：</p>
        <ol>
            <li>您可利用"分享"键将某些车抵典当服务内容分享到第三方服务，或您将第三方服务内容分享到车抵典当服务。这些功能会收集您的信息（包括您的日志信息），并在您的设备内装置COOKIES，从而正常运行上述功能；</li>
            <li>我们通过我们服务的其他方式向您提供链接，使您可以链接至第三方的服务或网站；</li>
            <li>其他接入第三方服务的情形。例如，为实现本政策中声明的目的，我们会接入第三方服务商提供的SDK或其他类似的应用程序（如以嵌入代码、插件等形式），以便向您提供更好的客户服务和用户体验。目前，我们接入的第三方服务商主要包括以下几种类型：</li>
            <ol>
                <li>用于消息推送功能，包括手机厂商Push推送、特定事件提醒等；</li>
                <li>用于支付相关服务，包括订单支付、交易行为核验、收入结算、支付信息汇总统计等；</li>
                <li>用于在您同意的情况下获取设备位置权限、搜集设备信息和日志信息等；</li>
                <li>用于第三方授权服务，包括第三方帐号登陆、将有关内容分享至第三方产品等；</li>
                <li>用于支持产品功能模块，包括在线直播、视频播放、语音识别、AR、智能客服、弹幕播放、内容存储等；</li>
                <li>用于优化产品性能，包括提高硬件配网能力、降低服务器成本、功能热修复等；</li>
                <li>用于帐号安全、产品加固相关服务，包括网络监测、域名解析、防劫持、反垃圾反作弊、加解密服务等；</li>
                <li>获取OAID（设备标识符，用于统计分析、广告归因及安全风控等）。</li>
            </ol>
            <li>集成第三方SDK目录</li>
        </ol>
        
        <div class="table-container">
        <table>
            <thead>
                <tr>
                    <th>SDK名称</th>
                    <th>开发者</th>
                    <th>隐私政策链接</th>
                    <th>使用目的说明</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>定位SDK</td>
                    <td>北京高德图强科技有限公司</td>
                    <td><a href="https://lbs.amap.com/pages/privacy/" target="_blank">https://lbs.amap.com/pages/privacy/</a></td>
                    <td>用于为您提供定位服务</td>
                </tr>
                <tr>
                    <td>OAID SDK（MSA）</td>
                    <td>移动安全联盟（MSA）</td>
                    <td><a href="https://www.msa-alliance.cn/col.jsp?id=122" target="_blank">https://www.msa-alliance.cn/col.jsp?id=122</a></td>
                    <td>用于获取OAID（设备标识符），以实现统计分析、广告归因及安全风控等；通常不需要额外申请敏感权限，具体以系统授权弹窗为准</td>
                </tr>
                <tr>
                    <td>微信OpenSDK Android</td>
                    <td>深圳市腾讯计算机系统有限公司</td>
                    <td><a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8" target="_blank">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a></td>
                    <td>用于支持微信内容分享功能</td>
                </tr>
                <tr>
                    <td>友盟+SDK</td>
                    <td>友盟+</td>
                    <td><a href="https://www.umeng.com/policy" target="_blank">https://www.umeng.com/policy</a></td>
                    <td>用于统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。</td>
                </tr>
            </tbody>
        </table>
        </div>
        
        <p>我们接入的部分第三方SDK或类似应用程序会收集您的个人信息，如您在我们的服务中使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。由于以上第三方服务由相关的第三方负责运营。您使用该等第三方的服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本政策）约束，您需要仔细阅读其条款。本政策仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。如您发现这些第三方社交媒体或其他服务存在风险时，建议您终止相关操作，您也可以选择通过本政策"如何联系我们"章节所列的渠道反馈给我们。</p>
        
        <h2>七、未成年人保护</h2>
        <ol>
            <li>未成年人通用条款
                <ol>
                    <li>若您是未满18周岁的未成年人，在使用我们相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本政策。</li>
                    <li>我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、共享或披露未成年人的个人信息；如果我们发现在未事先获得可证实父母或其他监护人同意的情况下收集了不满十四周岁未成年人的个人信息，则会设法尽快删除相关信息。</li>
                    <li>若您是未成年人的监护人，当您对您所监护的未成年人使用我们的服务或其向我们提供的用户信息有任何疑问时，请您及时与我们联系。</li>
                </ol>
            </li>
        </ol>
        
        <h2>八、修订和通知</h2>
        <p>为了给您提供更好的服务，我们会根据车抵典当服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分。我们会在本页面上公布对本政策所作的任何变更。对于重大变更，我们还会提供更为显著的通知（包括网站公告、推送通知、弹窗提示或其他方式），本政策所指的重要变更包括但不限于：</p>
        <ol>
            <li>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</li>
            <li>我们在所有权结构方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</li>
            <li>个人信息共享、转让或公开披露的主要对象发生重大变化；</li>
            <li>您参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
            <li>我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生重大变化；</li>
            <li>其他重要的或严重影响您的个人权益的情况发生。</li>
        </ol>
        
        <p>您如果不同意该等变更，可以选择停止使用车抵典当服务；如您仍然继续使用车抵典当服务的，即表示您已充分阅读、理解并同意受经修订的本政策的约束。</p>
        
        <p>我们的任何修改都会将您的满意度置于首位。我们鼓励您在每次使用车抵典当服务时都查阅我们的隐私政策。</p>
        
        <p>您可通过"我的→设置→隐私中心→用户隐私协议"路径访问本协议，全程不超过3次点击，链接位于界面顶部，无遮挡。</p>
        
        <p>我们在必需时（例如当我们由于系统维护而暂停某一单项服务、变更、终止提供某一单项服务时）向您发出与服务有关的通知。</p>
        
        <p>如您不希望继续接收我们推送的消息，您可要求我们停止推送，例如：根据短信退订指引要求我们停止发送推广短信，或在移动端设备中进行设置，不再接收我们推送的消息；但我们依法律规定或单项服务的服务协议约定发送消息的情形除外。</p>
        
        <h2>九、争议解决</h2>
        <p>您知晓且同意我们可自行决定不时修订本隐私通知。如对本隐私通知有任何重大变更，我们将通过页面提示、交互流程、公告或按照其他适用法律的方式通知您。您知晓并同意，如果您在新的隐私通知生效后继续使用服务，则视为您接受了更新后的隐私通知。</p>
        
        <p>本协议的签订地为我们公司注册地址所在地：江苏省苏州市金阊区，如果有争议且未得到妥善解决，您同意通过友好协商解决或者仅向苏州市金阊区当地法院提起诉讼请求。</p>
        
        <h2>十、如何联系我们</h2>
        <p>如您对本政策或其他相关事宜有疑问，请通过车抵典当客服或车抵典当官网载明的联系方式：18913109914 与我们联系。</p>
        
        <p>请在使用我们的服务前，仔细阅读并了解本隐私协议政策，您首次登录本应用时，我们将通过弹窗主动展示本协议摘要及全文链接，提供"同意使用"与"拒绝"按钮；若您选择"拒绝"，仅可浏览非登录功能，我们不会频繁弹窗挽留。在您点选"同意使用"之后，表示您完全理解和同意和接受本隐私协议的各项政策。</p>
        
        <p>公司名称：苏州汇通典当有限公司<br>
        公司地址：苏州市金阊区西环路2708号101室</p>
    </div>
</template>

<script>
import { ref, reactive } from 'vue'
export default {
    setup() {
        
    }
}

</script>
<style scoped>
/* 全局样式 */
* {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
            font-size: 14px;
            line-height: 1.8;
            color: #333;
            background-color: #f5f5f5;
            padding: 20px;
        }
        
        .container {
            max-width: 1000px;
            margin: 0 auto;
            padding: 40px;
            background-color: #fff;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
        }
        
        /* 标题样式 */
        h1 {
            font-size: 28px;
            font-weight: 700;
            color: #1a1a1a;
            margin: 1.5em 0 1em;
            text-align: center;
            line-height: 1.4;
        }
        
        h2 {
            font-size: 22px;
            font-weight: 600;
            color: #333;
            margin: 1.2em 0 0.8em;
            padding-bottom: 8px;
            border-bottom: 2px solid #e8e8e8;
        }
        
        h3 {
            font-size: 18px;
            font-weight: 600;
            color: #444;
            margin: 1em 0 0.6em;
        }
        
        h4 {
            font-size: 16px;
            font-weight: 600;
            color: #555;
            margin: 0.8em 0 0.5em;
        }
        
        /* 段落样式 */
        p {
            margin-bottom: 20px;
            text-align: justify;
            text-indent: 2em;
            line-height: 1.8;
        }
        
        /* 列表样式 */
        ul, ol {
            margin: 20px 0;
            padding-left: 2em;
        }
        
        li {
            margin-bottom: 12px;
            line-height: 1.8;
            text-align: justify;
        }
        
        /* 强调样式 */
        .highlight {
            font-weight: 600;
            color: #e53935;
            background-color: rgba(229, 57, 53, 0.05);
            padding: 2px 4px;
            border-radius: 3px;
        }
        
        .important {
            font-weight: 600;
            color: #1e88e5;
        }
        
        strong {
            font-weight: 600;
            color: #333;
        }
        
        /* 特殊标记样式 */
        .special-tip {
            background-color: #fff9e6;
            border-left: 4px solid #ffc107;
            padding: 15px 20px;
            margin: 20px 0;
            border-radius: 0 4px 4px 0;
        }
        
        .special-tip-title {
            color: #ff6600;
            font-weight: 600;
            margin-bottom: 10px;
            font-size: 16px;
        }
        
        /* 表格样式 - 添加可滚动容器 */
        .table-container {
            overflow-x: auto;
            margin: 20px 0;
            -webkit-overflow-scrolling: touch;
        }
        
        table {
            width: 100%;
            border-collapse: collapse;
            min-width: 600px;
            font-size: 13px;
        }
        
        th {
            background-color: #f2f2f2;
            border: 1px solid #ddd;
            padding: 10px;
            text-align: left;
            font-weight: 600;
            white-space: nowrap;
        }
        
        td {
            border: 1px solid #ddd;
            padding: 10px;
            vertical-align: top;
            white-space: nowrap;
        }
        
        tr:nth-child(even) {
            background-color: #f9f9f9;
        }
        
        /* 引用样式 */
        blockquote {
            margin: 20px 0;
            padding: 10px 20px;
            background-color: #f5f5f5;
            border-left: 4px solid #ccc;
            font-style: italic;
        }
        
        /* 链接样式 */
        a {
            color: #1e88e5;
            text-decoration: none;
        }
        
        a:hover {
            text-decoration: underline;
        }
        
        /* 代码样式 */
        code {
            font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
            background-color: #f5f5f5;
            padding: 2px 4px;
            border-radius: 3px;
            font-size: 13px;
        }
        
        pre {
            background-color: #f5f5f5;
            padding: 15px;
            border-radius: 4px;
            overflow-x: auto;
            margin: 20px 0;
        }
        
        pre code {
            background-color: transparent;
            padding: 0;
        }
        
        /* 响应式设计 */
        @media (max-width: 768px) {
            body {
                padding: 10px;
            }
            
            .container {
                padding: 20px;
                margin: 10px;
                border-radius: 4px;
            }
            
            h1 {
                font-size: 24px;
            }
            
            h2 {
                font-size: 20px;
            }
            
            h3 {
                font-size: 16px;
            }
            
            table {
                font-size: 12px;
            }
            
            th, td {
                padding: 8px;
            }
        }
.date-info{
    font-size: 14px;
    color: #666;
    text-align: right;
    margin-bottom: 16px;
}
</style>